// import { authPages } from "./auth";

export const disabledGoToAppOnPages: string[] = [
  '/searchEvents',
  '/onboarding'
  // ...authPages
]